module.exports = __webpack_public_path__ + "img/step_2.2a8f8737.png";